(() => {
  const init = () => {
    const page = document.querySelector('#productHead[data-product_id="16672176865625"]');
    const root = page?.querySelector('[data-jw-catalog]');
    const template = document.querySelector('#jw-heart-controls');
    if (!root || !template || root.dataset.heartReady) return;
    const finish = root.querySelector('[data-option-index="0"]');
    const count = root.querySelector('[data-option-index="1"]');
    if (!finish || !count) return;
    root.dataset.heartReady = 'true';
    page.classList.add('jw-heart-page');
    const content = template.content.cloneNode(true);
    const buttons = content.querySelector('.jw-heart-finishes');
    const names = content.querySelector('.jw-heart-names');
    finish.closest('.jw-field').hidden = true;
    root.querySelector('.jw-variant-fields').before(buttons);
    root.querySelector('.jw-personal-fields').append(names);
    const radios = [...buttons.querySelectorAll('input')];
    const fields = [...names.querySelectorAll('[data-heart-name]')];
    const sync = (showImage = false) => {
      radios.forEach(radio => { radio.checked = radio.value === finish.value; });
      fields.forEach(field => {
        const active = Number(field.dataset.heartName) <= Number(count.value);
        field.hidden = !active;
        const input = field.querySelector('input');
        input.disabled = !active;
        input.required = active;
      });
      if (showImage) {
        const label = finish.value === 'Dorée' ? 'Finition or —' : finish.value === 'Or rose' ? 'Finition or rose —' : 'Finition argent —';
        const thumb = [...page.querySelectorAll('[data-jw-thumb]')].find(button => button.dataset.alt.startsWith(label));
        thumb?.click();
      }
    };
    radios.forEach(radio => radio.addEventListener('change', () => {
      if (!radio.checked) return;
      finish.value = radio.value;
      finish.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    root.addEventListener('change', event => {
      if (event.target === finish || event.target === count) sync(event.target === finish);
    });
    const form = root.closest('form');
    form.querySelectorAll('.shopify-payment-button,.product-form__item--payment-button').forEach(el => { el.hidden = true; });
    const validate = event => {
      fields.forEach(field => {
        const input = field.querySelector('input');
        input.setCustomValidity(!input.disabled && !input.value.trim() ? input.placeholder : '');
      });
      if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
    };
    names.addEventListener('input', event => event.target.setCustomValidity?.(''));
    form.addEventListener('submit', validate, true);
    form.addEventListener('click', event => { if (event.target.closest('[name="add"]')) validate(event); }, true);
    sync(new URL(location.href).searchParams.has('variant'));
    window.addEventListener('pageshow', () => sync(true));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
